import CandidateForm from 'views/CandidateForm';
import GameLoader from 'views/GameLoader';
import RulesScreen from 'views/RulesScreen';
import LanguageSelectionScreen from 'views/LanguageSelectionScreen';

export const PROTECTED_ROUTES = [
  {
    path: '/language-selection/:id',
    component: LanguageSelectionScreen,
  },
  {
    path: '/form/:id',
    component: CandidateForm,
  },
  {
    path: '/rules/:id',
    component: RulesScreen,
  },
  {
    path: '/games/:id',
    component: GameLoader,
  },
];
